import React from "react";
import { Modal, Input, Form, Select } from "antd";
import { VALIDAR_STOCK } from "../../../common/types/parametroType";
import { PRECIO_VENTA } from "../../../common/types/tipoListaPrecioType";
import auth from "../../../common/utility/auth";
const { Option } = Select;

class FormModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      console.log(values);
      if (!err) {
        const form = {
          id: values.id,
          nombre: values.nombre,
          idEstablecimiento: values.idEstablecimiento.key,
          idTipoListaPrecio:
            values.idTipoListaPrecio === undefined
              ? PRECIO_VENTA
              : values.idTipoListaPrecio.key,
        };
        this.props.onSave(form, this.props.form);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    getFieldDecorator("id", { initialValue: this.props.formValues.id });

    const validarStock =
      auth.user().parametros.filter((m) => m.abreviatura === VALIDAR_STOCK)[0]
        .valor === "1"
        ? true
        : false;
    return (
      <Modal
        title={
          this.props.formValues.id === 0
            ? "Registrar Lista de Precio"
            : "Modificar Lista de Precio"
        }
        visible={this.props.visible}
        cancelText={"Cancelar"}
        okText={"Guardar"}
        onCancel={this.handleCancel}
        onOk={this.handleOk}
        style={{ top: 30 }}
      >
        <Form>
          <div className="row">
            <div className="col-md-12 form-group">
              <Form.Item label="Nombre">
                {getFieldDecorator("nombre", {
                  initialValue: this.props.formValues.nombre,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                      whitespace: true,
                    },
                  ],
                })(<Input placeholder="Ingresar Nombre" autoComplete="off" />)}
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 form-group">
              <Form.Item label="Establecimiento">
                {getFieldDecorator("idEstablecimiento", {
                  initialValue: this.props.formValues.idEstablecimiento
                    ? { key: this.props.formValues.idEstablecimiento }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Establecimiento"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.establecimientos.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
          </div>
          {validarStock ? (
            <div className="row">
              <div className="col-md-12 form-group">
                <Form.Item label="Tipo Lista Precio">
                  {getFieldDecorator("idTipoListaPrecio", {
                    initialValue: this.props.formValues.idTipoListaPrecio
                      ? { key: this.props.formValues.idTipoListaPrecio }
                      : undefined,
                    rules: [
                      {
                        required: true,
                        message: "Campo obligatorio.",
                      },
                    ],
                  })(
                    <Select
                      showSearch
                      labelInValue
                      placeholder={"Seleccione Tipo Lista de Precio"}
                      optionFilterProp="children"
                    >
                      {this.props.formValues.tiposListaPrecio.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.nombre}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </div>
            </div>
          ) : null}
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(FormModal);
